import { render, staticRenderFns } from "./I18nEntityManagement.vue?vue&type=template&id=784b5978&scoped=true"
import script from "./I18nEntityManagement.vue?vue&type=script&lang=js"
export * from "./I18nEntityManagement.vue?vue&type=script&lang=js"
import style0 from "./I18nEntityManagement.vue?vue&type=style&index=0&id=784b5978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784b5978",
  null
  
)

export default component.exports